/*
  Ellada : fiche produit.
  - Dates de livraison estimées (jours ouvrés, calculées chez la cliente).
  - Suggestion pour atteindre la livraison offerte (recommandations Shopify).
  - Ajout au panier groupé (parure) et ouverture du tiroir panier de Dawn.
  - Barre d'achat collante.
*/
(function () {
  if (window.elladaProduct) return;
  window.elladaProduct = true;

  var fmtDate = function (d) {
    return d.toLocaleDateString(document.documentElement.lang || 'fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
  };

  var addBusinessDays = function (date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  };

  var money = function (cents) {
    var devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: devise }).format(cents / 100);
  };

  /* Ajout au panier puis ouverture du tiroir (même mécanique que product-form.js de Dawn) */
  window.elladaAddToCart = function (items) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || response.message);
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
        return response;
      });
  };

  function initLivraison(root) {
    root.querySelectorAll('[data-ellada-livraison]').forEach(function (el) {
      var prep = parseInt(el.dataset.prep, 10) || 0;
      var min = parseInt(el.dataset.min, 10) || 2;
      var max = parseInt(el.dataset.max, 10) || min;
      var now = new Date();
      var depart = addBusinessDays(now, prep);
      el.querySelector('[data-date-min]').textContent = fmtDate(addBusinessDays(depart, min));
      el.querySelector('[data-date-max]').textContent = fmtDate(addBusinessDays(depart, max));
      el.hidden = false;
    });
  }

  function initOfferte(root) {
    root.querySelectorAll('[data-ellada-offerte]').forEach(function (el) {
      var seuil = parseInt(el.dataset.seuil, 10);
      var prix = parseInt(el.dataset.prix, 10);
      fetch(window.routes.cart_url + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price + prix;
          if (total >= seuil) return null;
          var manque = seuil - total;
          var url = el.dataset.recoUrl + '.json?product_id=' + el.dataset.productId + '&limit=8&intent=related';
          return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
            var dansPanier = cart.items.map(function (i) { return i.product_id; });
            var choix = (data.products || []).filter(function (p) {
              return p.available && p.price >= manque && dansPanier.indexOf(p.id) === -1;
            }).sort(function (a, b) { return a.price - b.price; })[0];
            if (!choix) return null;
            var variante = (choix.variants || []).filter(function (v) { return v.available; })[0];
            if (!variante) return null;
            el.querySelector('[data-offerte-nom]').textContent = choix.title;
            el.querySelector('[data-offerte-prix]').textContent = money(choix.price);
            if (choix.featured_image) {
              var img = document.createElement('img');
              img.src = choix.featured_image + (choix.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              img.alt = '';
              img.width = 40;
              img.height = 40;
              img.loading = 'lazy';
              el.querySelector('[data-offerte-image]').appendChild(img);
            }
            el.querySelector('[data-offerte-ajouter]').addEventListener('click', function (event) {
              event.currentTarget.disabled = true;
              window.elladaAddToCart([{ id: variante.id, quantity: 1 }]).then(function () {
                el.hidden = true;
              }).catch(function () {
                event.currentTarget.disabled = false;
              });
            });
            el.hidden = false;
          });
        })
        .catch(function () {});
    });
  }

  function initBarreAchat() {
    var barre = document.querySelector('[data-ellada-barre-achat]');
    if (!barre) return;
    var principal = document.querySelector('product-info .product-form__submit');
    if (!principal || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        barre.classList.toggle('is-visible', visible);
        barre.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    });
    observer.observe(principal);
    var bouton = barre.querySelector('[data-barre-ajouter]');
    if (bouton) {
      bouton.addEventListener('click', function () {
        principal.click();
      });
    }
    var majInfos = function () {
      var variante = document.querySelector('product-info .product-variant-id');
      var titre = barre.querySelector('[data-barre-variante]');
      var prix = document.querySelector('product-info .price__regular .price-item--regular, product-info .price-item--sale');
      if (titre) {
        var selection = Array.from(document.querySelectorAll('product-info variant-selects input:checked, product-info variant-selects select'))
          .map(function (i) { return i.tagName === 'SELECT' ? i.options[i.selectedIndex].text : i.value; })
          .join(', ');
        titre.textContent = selection;
      }
      var prixBarre = barre.querySelector('[data-barre-prix]');
      if (prix && prixBarre) prixBarre.textContent = prix.textContent.trim();
      if (variante && bouton) bouton.disabled = principal.disabled;
    };
    majInfos();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(majInfos, 50); });
    }
  }

  function initParure(root) {
    root.querySelectorAll('[data-ellada-parure]').forEach(function (el) {
      var cases = Array.from(el.querySelectorAll('[data-parure-case]'));
      var total = el.querySelector('[data-parure-total]');
      var offerte = el.querySelector('[data-parure-offerte]');
      var bouton = el.querySelector('[data-parure-ajouter]');
      var seuil = parseInt(el.dataset.seuil || '0', 10);
      var maj = function () {
        var somme = 0;
        var n = 0;
        cases.forEach(function (c) {
          var carte = c.closest('[data-parure-produit]');
          carte.classList.toggle('is-off', !c.checked);
          if (c.checked) {
            somme += parseInt(c.dataset.prix, 10);
            n++;
          }
        });
        if (total) total.textContent = money(somme);
        if (offerte) offerte.hidden = !(seuil > 0 && somme >= seuil);
        if (bouton) bouton.disabled = n === 0;
      };
      cases.forEach(function (c) { c.addEventListener('change', maj); });
      if (bouton) {
        bouton.addEventListener('click', function () {
          var items = cases.filter(function (c) { return c.checked; }).map(function (c) {
            return { id: parseInt(c.dataset.variante, 10), quantity: 1 };
          });
          if (!items.length) return;
          bouton.disabled = true;
          window.elladaAddToCart(items).finally(function () { bouton.disabled = false; });
        });
      }
      maj();
    });
  }

  window.elladaInitParure = initParure;

  function init(root) {
    initLivraison(root);
    initOfferte(root);
    initParure(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initBarreAchat();
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
